const mobileAppStyles = {
  container: {
    width: '100%',
    transition: 'all 0.3s ease-in-out',
    borderRadius: 16,
    overflow: 'hidden',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
    }
  },
  contentWrapper: {
    display: 'flex',
    alignItems: 'center',
    padding: '24px',
    gap: '24px',
    // Three columns leave the text a word wide on a phone: icon and text on top, badges below.
    '@media (max-width: 599px)': {
      flexWrap: 'wrap',
      padding: '16px',
      gap: '16px',
    },
  },
  leftSection: {
    flex: '0 0 auto',
  },
  middleSection: {
    flex: '1 1 auto',
    minWidth: 0,
    paddingRight: '16px',
    '@media (max-width: 599px)': {
      flex: '1 1 0',
      paddingRight: 0,
    },
  },
  rightSection: {
    flex: '0 0 240px',
    '@media (max-width: 599px)': {
      flex: '1 1 100%',
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconWrapper: {
    width: '100px',
    height: '100px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '24px',
    padding: '16px',
    '@media (max-width: 599px)': {
      width: '64px',
      height: '64px',
      padding: 0,
    },
  },
  icon: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    borderRadius: 16,
  },
  title: {
    fontWeight: 600,
    marginBottom: '8px',
    color: '#1a1a1a',
    fontSize: '1.5rem',
    lineHeight: 1.2,
  },
  comment: {
    color: '#666666',
    fontSize: '1rem',
    lineHeight: 1.5,
  },
  divider: {
    margin: '0 8px',
    height: '80%',
    alignSelf: 'center',
    '@media (max-width: 599px)': {
      display: 'none',
    },
  },
  storeButtons: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
    alignItems: 'center',
    '@media (max-width: 599px)': {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: '12px',
    },
  },
  storeLink: {
    textDecoration: 'none',
    transition: 'transform 0.2s ease-in-out',
    display: 'inline-block',
    '&:hover': {
      transform: 'scale(1.05)',
    }
  },
  storeBadge: {
    height: '50px',
    width: '160px',
    objectFit: 'fill',
    borderRadius: '8px',
    '@media (max-width: 599px)': {
      height: '44px',
      width: '140px',
    },
  }
};

export default mobileAppStyles;